import { Utilities, ModalAction } from '../Utility/Utilities';
import * as toastr from "toastr";
import * as events from '../Bus/Bus';
import { IAPIResult, ICAMSKey, FeatureType, TextPack } from '../Models/UtilityModels';
import { ICAMSContact, ContactListConfig } from '../Contacts/ContactsModels';
import { UserDefinedFields } from '../UserDefinedFields/UserDefinedFields';
import { CustomFilter, CustomFilterField, CustomFilterOperator, CustomFilterType } from '../Models/CustomFilterModels';
import { ModalPrompts, PredefinedModalEnum } from '../Utility/ModalPrompts';

// Exported models 
export enum ActivityListType {
    AssignedTo,
    RecordedBy,
    MyActivities,
    MaintActivity,
    InfraActivity,
    RouteActivity,
    LandActivity,
    TaskActivity,
    TaskGroupActivity,
    PathActivity,
    LegalEventActivity,
    TROActivity
}

export class ActivityListRequestModel {
    ID: string;
    ActivityListType: ActivityListType;
    Filter: ActivityListFilter;
    Skip: number;
    Take: number;
}

export enum ActivityListFilter {
    All
}

export class ActivityCreateModel {
    ID: string;
    activityListType: ActivityListType;
    contactRef?: String;
    affiliation?: String;
}

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
}

export class Activity {

    // ----------------------------------------------------------- //
    // GLOBAL VARS

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this; 
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openActivityListIntoElement = (el: any, model: ActivityListRequestModel, parentModel: any): void => {
        const self = this;
 
        // Bind events when the popover is shown
        el.off("show.bs.popover");
        el.on("show.bs.popover", function () {
            //$($(this).data("bs.popover").getTipElement()).css("max-width", "300px");
        });

        el.off("shown.bs.popover");
        el.on("shown.bs.popover", function () {
            // reposition so it does not overlap the modal
            //$('.popover').css('left', '-100px');
            //$('.arrow').css('left', '189px');

            //$(".popover-close-btn").click(function () {
            //    el.popover("hide");
            //});

            let popoverEl = $('[data-popper-reference-hidden]');
            let popoverBody = popoverEl.find(".popover-body");
            if (popoverBody.length == 0) {
                var tmpEl = document.createElement("div");
                $(tmpEl).addClass("popover-body");
                popoverEl.append(tmpEl);
                popoverBody = popoverEl.find(".popover-body");
            }
            popoverEl.find(".popover-header").html(popoverTitleDiv);
            
            $('#newActivityBtn').on('click', function () {
                if (parentModel != null) parentModel.modal('hide');
                self.openNewActivityPanel({ ID: model.ID, activityListType: model.ActivityListType}, function () {
                    if (parentModel != null) parentModel.modal('show');
                });
            });

            //Utilities.BlockUI($(".popover"));
            popoverBody.load('/Activity/ActivityList', model, function (response, status, xhr) {
                //Utilities.UnBlockUI($(".popover"));
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }

                // Bind rows
                $('[data-activityid]').on("click", function () {
                    if (parentModel != null) parentModel.modal('hide');
                    let activityID = $(this).data("activityid");
                    self.openActivityDetailsPanel(activityID, function () { if (parentModel != null) parentModel.modal('show'); });
                });

            });

        });

        // Create and show the popover
        let popoverTitleDiv =
            "<div class='d-flex justify-content-between'>" +
                "<div class='p'>Recent activites</div>" +
                "<i id='newActivityBtn' class='btn btn-light fas fa-plus' style='cursor: pointer; padding: unset;'></i>" +
            "</div>";
        el.attr('data-original-title', popoverTitleDiv);

        el.popover({
            html: true,
            toggle: 'popover',
            trigger: 'click',
            title: popoverTitleDiv,
            placement: 'bottom',
            content: "Loading..."
        });

        // Show the popover
        el.popover('show');      
    }

    public openActivityDetailsPanel = (activityID: number, callback: Function): void => {
        const self = this;

        Utilities.BlockUI();
        $('#placeholder-for-activitymodals').load(window.G_SITEFOLDERNAME +'/Activity/ActivityDetail', { activityID: activityID }, function (response, status, xhr) {
            Utilities.UnBlockUI();
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }

            Utilities.GetModal('#activityEditModal', ModalAction.Create);

            // Get UDF's and conditional fields
            $().on('change', function () {
                UserDefinedFields.ShowHideUDFs(<string>$().children("option:selected").val(), $("#activityEditForm"));
            });
            UserDefinedFields.ShowHideUDFs(<string>$().children("option:selected").val(), $("#activityEditForm"));

            // Get form validation
            Utilities.InitFormValidation($("#activityEditForm"));

            $('#activityEditForm_assignToBtn').on("click", function () {
                function contactCallback(c: Array<ICAMSContact>) {
                    Utilities.GetModal('#activityEditModal', ModalAction.Show);
                    if (c != null && c.length > 0) { 
                        $('#activityEditForm  [name="ContactRefListName"]').val(c[0].ListName);
                        $('#activityEditForm [name="ContactRef"]').val(c[0].ContactRef);
                    }
                }

                // Open the contacts list view
                Utilities.GetModal('#activityEditModal', ModalAction.Hide);
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                events.bus.publish(events.eventOpenContactsListView([false, btns, contactCallback]));
            });

            $('#activityEditSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#activityEditForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI();

                let formData = new FormData(<any>$('#activityEditForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Activity/UpdateActivity',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                UserDefinedFields.SaveUDFFieldsAtServer($('#activityEditForm'), '/Activity/UpdateActivityUserFields');
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                                if (callback != null) callback(true);
                            }
                            else {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditFailed" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.GetModal('#activityEditModal', ModalAction.Hide);
                            Utilities.UnBlockUI();
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                    Utilities.UnBlockUI();
                });
            });
            $('#activityEditDeleteBtn').on('click', function (evt) {
                self.deleteEntity(activityID, callback);
            });
            $('#activityEditCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#activityEditModal', ModalAction.Hide);
                if (callback != null) callback(false);
            });
            $('#activityEditCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#activityEditModal', ModalAction.Hide);
                if (callback != null) callback(false);
            });
        });
    }

    public openNewActivityPanel = (model: ActivityCreateModel , callback: Function): void => {
        const self = this;
    
        Utilities.BlockUI();
        $('#placeholder-for-activitymodals').load(window.G_SITEFOLDERNAME +'/Activity/ActivityCreate', model, function (response, status, xhr) {
            Utilities.UnBlockUI();
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }

            Utilities.GetModal('#activityCreateModal', ModalAction.Create);

            // Get form validation
            Utilities.InitFormValidation($("#activityCreateModal"));

            $('#activityCreateForm_contactRefToBtn').on("click", function () {
                function contactCallback(c: Array<ICAMSContact>) {
                    Utilities.GetModal('#activityCreateModal', ModalAction.Show);
                    if (c != null && c.length > 0) {
                        $('#activityCreateForm  [name="ContactRefListName"]').val(c[0].ListName);
                        $('#activityCreateForm [name="ContactRef"]').val(c[0].ContactRef);
                    }
                }

                // Open the contacts list view
                Utilities.GetModal('#activityCreateModal', ModalAction.Hide);
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                events.bus.publish(events.eventOpenContactsListView([false, btns, contactCallback]));
            });

            $('#activityCreateSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#activityCreateForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI();

                let formData = new FormData(<any>$('#activityCreateForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Activity/AddActivity',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                //self.openActivityDetailsPanel(result.code as any, callback);
                                if (callback != null) callback(true);
                            }
                            else {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.GetModal('#activityCreateModal', ModalAction.Hide);
                            Utilities.UnBlockUI();
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                    Utilities.UnBlockUI();
                });
            });
            $('#activityCreateCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#activityCreateModal', ModalAction.Hide);
                if (callback != null) callback(false);
            });

            $('#activityCreateCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#activityCreateModal', ModalAction.Hide);
                if (callback != null) callback(false);
            });
        });
    }

    // ----------------------------------------------------------- //
    // GET ACTIVITIES
    public getActivities = (data: ICAMSKey, excludeAuditTypes: Boolean, callback: Function): void => {
        var fieldName = "";
        switch (data.featureType.toString()) {
            case FeatureType.Maint.toString(): fieldName = "MaintCode"; break;
            case FeatureType.Infra.toString(): fieldName = "InfraCode"; break;
            case FeatureType.Route.toString(): fieldName = "RouteCode"; break;
            case FeatureType.Land.toString(): fieldName = "LandCode"; break;
            case FeatureType.Path.toString(): fieldName = "RouteCode"; break;
            case FeatureType.Task.toString(): fieldName = "JobID"; break;
            case FeatureType.LegalEvent.toString(): fieldName = "LegalCode"; break;
            default: toastr.error('Failed to get Activities for feature: ' + data.code); return;
        }

        var customFilters: Array<CustomFilter> = [];
        customFilters.push({
            field: { fieldName: fieldName, fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Equals]  },
            operator: CustomFilterOperator.Equals,
            searchValue: data.code
        });

        if (excludeAuditTypes == true) {
            customFilters.push({
                field: { fieldName: "ActivityTypeLUT.AuditYesNo", fieldType: CustomFilterType.Boolean, operators: [CustomFilterOperator.Equals] },
                operator: CustomFilterOperator.Equals,
                searchValue: "0"
            });
        }

        $.post(window.G_SITEFOLDERNAME + '/Activity/GetActivities', { customFilters: customFilters },
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        callback(result.data);
                    }
                    else {
                        toastr.error('Failed to get Activities!');
                        callback(null);
                    }
                }
                catch (err) {
                    console.log(err);
                    callback(null);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // DELETE
    public deleteEntity = (activityID: number, callback: Function): void => {
        const self = this;

        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            Utilities.BlockUI();
            $.post('/Activity/DeleteActivity', { activityID: activityID },
                function (result: IAPIResult) {
                    Utilities.UnBlockUI();                    
                    try {
                        if (result.success == true) {
                            Utilities.GetModal('#activityEditModal', ModalAction.Hide);
                            if (callback != null) callback(true);
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                        }
                        else {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    // ----------------------------------------------------------- //
    // MISC
    
}




